import React, { SyntheticEvent, useState } from 'react';
import styled from 'styled-components';
import { Icon, IconName, IconProps } from '../icon';
import { SpriteAnimation } from '../sprite-animation';
import { Flex } from '../primitives';
import { theme as UITheme } from '../../theme';
import heartSpriteIcon from '../../assets/images/heart-animation.svg';

type Props = {
  onClick: (event: SyntheticEvent) => void;
  isInFinalState: boolean;
  initialIconType?: IconName;
  finalIconType?: IconName;
  iconConfig?: Omit<IconProps, 'name'>;
  spriteConfig?: {
    uri: string;
    width: number;
    height: number;
    stepCount: number;
    spriteWidth: number;
    duration?: number;
  };
  wrapperConfig?: {
    width: number | string;
    height: number | string;
  };
  animationDuration?: number;
};

const AnimatedIcon = ({
  initialIconType = 'heart',
  finalIconType = 'heart-full',
  iconConfig = {
    size: 24,
    color: UITheme.colors.accent,
  },
  spriteConfig = {
    uri: heartSpriteIcon,
    width: 50,
    height: 50,
    stepCount: 29,
    spriteWidth: 1500,
  },
  wrapperConfig = {
    width: 50,
    height: 50,
  },
  isInFinalState,
  onClick,
  animationDuration = 800,
}: Props) => {
  const [isAnimating, setIsAnimating] = useState(false);

  const onIconClick = (event: SyntheticEvent) => {
    event.persist();
    event.stopPropagation();

    setIsAnimating(true);

    setTimeout(() => {
      onClick(event);
    }, animationDuration);
  };

  return (
    <Flex alignItems="center" justifyContent="center" {...wrapperConfig}>
      {isAnimating && <SpriteAnimation {...spriteConfig} />}
      {!isAnimating && isInFinalState && (
        <Icon {...iconConfig} name={finalIconType} />
      )}

      {!isAnimating && !isInFinalState && (
        <SButton onClick={onIconClick} data-test="animated-icon-click">
          <Icon {...iconConfig} name={initialIconType} />
        </SButton>
      )}
    </Flex>
  );
};

const SButton = styled.div`
  background: none;
  border: none;
  outline: none;
  display: flex;
  flex: 1;
  height: 100%;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 0;
  pointer-events: auto;
`;

export default AnimatedIcon;
